import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _classPrivateFieldLooseBase from "@babel/runtime/helpers/esm/classPrivateFieldLooseBase";
import _classPrivateFieldLooseKey from "@babel/runtime/helpers/esm/classPrivateFieldLooseKey";
import RefreshTokenCache from "./RefreshTokenCache.js";
import TokenCache from "./TokenCache.js";
import { JWTCacheError, JWTRenewError, UnloggedError } from "./AuthErrors.js";
import { buildUrl } from "./utils.js"; // Types
import { AUTH_PATH, AUTH_TYPE, QUERY_PARAMS_TYPE } from "./types.js";
const REQUEST_DELAY = 15;
var _refreshToken = /*#__PURE__*/_classPrivateFieldLooseKey("refreshToken");
class AuthBase {
  /**
   * Allows us to know if fetch response will contain a response
   * body or not.
   * This is used to avoid spreading the response body if it's
   * undefined
   */
  get fetchShouldHaveReponse() {
    return this.tokenOutputType === QUERY_PARAMS_TYPE.PAYLOAD || this.refreshTokenOutputType === QUERY_PARAMS_TYPE.PAYLOAD;
  }
  constructor({
    host,
    customFetch = globalThis.fetch,
    requestDelay = REQUEST_DELAY,
    tokenOutputType = QUERY_PARAMS_TYPE.PAYLOAD,
    refreshTokenOutputType = QUERY_PARAMS_TYPE.COOKIE,
    refreshTokenCache
  }) {
    Object.defineProperty(this, _refreshToken, {
      value: _refreshToken2
    });
    this.host = void 0;
    this.fetch = void 0;
    this.requestDelay = void 0;
    this.tokenOutputType = void 0;
    this.refreshTokenOutputType = void 0;
    this.tokenCache = null;
    this.refreshTokenCache = null;
    this.host = host;
    this.fetch = customFetch;
    this.requestDelay = requestDelay;
    this.tokenOutputType = tokenOutputType;
    this.refreshTokenOutputType = refreshTokenOutputType;
    if (this.tokenOutputType === QUERY_PARAMS_TYPE.PAYLOAD) {
      this.tokenCache = new TokenCache(null, this.requestDelay);
    }
    if (this.refreshTokenOutputType === QUERY_PARAMS_TYPE.PAYLOAD) {
      this.refreshTokenCache = refreshTokenCache || new RefreshTokenCache();
    }
  }
  getToken() {
    var _this = this;
    return _asyncToGenerator(function* () {
      var _this$tokenCache;
      if ((_this$tokenCache = _this.tokenCache) != null && _this$tokenCache.isValid()) {
        return _this.tokenCache.get();
      }
      yield _classPrivateFieldLooseBase(_this, _refreshToken)[_refreshToken]();
      if (_this.tokenCache && _this.tokenCache.get()) {
        if (_this.tokenCache.isValid()) {
          return _this.tokenCache.get();
        }
        throw new JWTCacheError('Could not fetch valid JWT Token');
      }
      return null;
    })();
  }
  invalidateCurrentToken() {
    var _this$tokenCache2, _this$refreshTokenCac;
    (_this$tokenCache2 = this.tokenCache) == null || _this$tokenCache2.invalidate();
    (_this$refreshTokenCac = this.refreshTokenCache) == null || _this$refreshTokenCac.invalidate();
  }
  logout() {
    var _this2 = this;
    return _asyncToGenerator(function* () {
      _this2.invalidateCurrentToken();
      const fetchUrl = `https://${_this2.host}/${AUTH_PATH.LOGOUT}`;
      yield _this2.fetch.call(null, fetchUrl, {
        method: 'GET',
        credentials: 'include'
      }).catch(() => {
        throw new Error('Could not invalidate current tokens');
      });
    })();
  }
}
function _refreshToken2() {
  return _refreshToken3.apply(this, arguments);
}
function _refreshToken3() {
  _refreshToken3 = _asyncToGenerator(function* () {
    var _this$refreshTokenCac2;
    const refreshToken = (_this$refreshTokenCac2 = this.refreshTokenCache) == null ? void 0 : _this$refreshTokenCac2.get();
    let inputType = QUERY_PARAMS_TYPE.COOKIE;
    let body;
    let credentials = 'include';
    if (refreshToken) {
      inputType = QUERY_PARAMS_TYPE.PAYLOAD;
      body = JSON.stringify({
        refresh_token: refreshToken
      });
      credentials = 'omit';
    }
    const fetchUrl = buildUrl({
      host: this.host,
      authType: AUTH_TYPE.RENEW,
      inputType,
      tokenOutputType: this.tokenOutputType,
      refreshTokenOutputType: this.refreshTokenOutputType
    });
    const response = yield this.fetch.call(null, fetchUrl, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body,
      credentials
    }).catch(() => {
      throw new JWTRenewError('Could not fetch JWT Token');
    });
    if (!response.ok) {
      throw new UnloggedError('Could not fetch JWT Token');
    }
    if (this.fetchShouldHaveReponse) {
      var _this$tokenCache3, _this$refreshTokenCac3;
      const {
        jwt,
        refresh_token
      } = yield response.json();
      (_this$tokenCache3 = this.tokenCache) == null || _this$tokenCache3.set(jwt);
      (_this$refreshTokenCac3 = this.refreshTokenCache) == null || _this$refreshTokenCac3.set(refresh_token);
    }
    return null;
  });
  return _refreshToken3.apply(this, arguments);
}
export default AuthBase;
//# sourceMappingURL=AuthBase.js.map